module.exports = {
	"id": "GM",
	"name": "Gambia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.02124,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.00354,
			"17": 0.01062,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": 0.02124,
			"24": null,
			"25": 0.04956,
			"26": 0.0177,
			"27": 0.00354,
			"28": null,
			"29": 0.00354,
			"30": 0.04248,
			"31": 0.02832,
			"32": 0.01416,
			"33": 0.02124,
			"34": 0.01062,
			"35": null,
			"36": 0.07434,
			"37": null,
			"38": 0.01062,
			"39": 0.02478,
			"40": 0.01062,
			"41": 0.02478,
			"42": 0.00708,
			"43": 0.16284,
			"44": 0.01062,
			"45": 0.03894,
			"46": 0.02124,
			"47": 0.06018,
			"48": 0.02124,
			"49": 0.88854,
			"50": 0.0708,
			"51": 1.2921,
			"52": 0.20532,
			"53": 11.24304,
			"54": 2.19834,
			"55": 0.13806,
			"56": 0.02832,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.11328,
			"4": 0.04956,
			"5": null,
			"6": 0.00708,
			"7": 0.00354,
			"8": 0.00708,
			"9": null,
			"10": null,
			"11": 0.09558,
			"12": 0.0354,
			"13": 0.01416,
			"14": 0.02478,
			"15": 0.02124,
			"16": null,
			"17": 0.01416,
			"18": null,
			"19": null,
			"20": 0.0177,
			"21": 0.01062,
			"22": 0.00354,
			"23": 0.01062,
			"24": null,
			"25": 0.01062,
			"26": 0.00708,
			"27": null,
			"28": 0.00708,
			"29": 0.08496,
			"30": 0.03894,
			"31": 0.02478,
			"32": 0.01062,
			"33": 0.02124,
			"34": 0.00708,
			"35": 0.02832,
			"36": 0.08142,
			"37": 0.05664,
			"38": 0.0354,
			"39": 0.1593,
			"40": 0.04602,
			"41": 0.03894,
			"42": 0.0531,
			"43": 0.32214,
			"44": 0.354,
			"45": 0.08496,
			"46": 0.15576,
			"47": 0.98412,
			"48": 0.8673,
			"49": 6.27288,
			"50": 2.61252,
			"51": 0.00708,
			"52": null,
			"3.5": null,
			"3.6": 0.01062
		},
		"opera": {
			"9": null,
			"11": 0.00354,
			"12": 0.00708,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.00708,
			"21": 0.0354,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.01416,
			"29": 0.04248,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.0354,
			"34": null,
			"35": 0.00708,
			"36": 0.06372,
			"37": 0.0531,
			"38": 0.0177,
			"39": 0.01416,
			"40": 0.6903,
			"41": 0.0885,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": 0.00708,
			"11.6": 0.01416,
			"12.1": 0.01062
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.01062,
			"6": null,
			"7": null,
			"8": 0.04248,
			"9": 0.02832,
			"10": 0.16992,
			"3.1": null,
			"3.2": null,
			"5.1": 0.0177,
			"6.1": 0.01062,
			"7.1": null,
			"9.1": 0.24072
		},
		"ios_saf": {
			"8": 0,
			"10": 3.0426492423,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.081995876353,
			"8.1-8.4": 0.151483907161,
			"9.0-9.2": 0.07226755204,
			"9.3": 1.10254342215
		},
		"android": {
			"3": 0,
			"4": 0.164521343669,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0205651679587,
			"4.1": 0.593451989664,
			"4.2-4.3": 1.48362997416,
			"4.4": 3.40206635659,
			"4.4.3-4.4.4": 3.43144516796
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.14868,
			"9": 0.10974,
			"10": 0.09912,
			"11": 1.40184,
			"5.5": null
		},
		"op_mob": {
			"0": 1.69467700995,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0470743613876
		},
		"edge": {
			"12": 0.2301,
			"13": 0.22302,
			"14": 0.13098
		},
		"ie_mob": {
			"10": 0.286605633803,
			"11": 1.1668943662
		},
		"bb": {
			"7": 0.05168,
			"10": null
		},
		"samsung": {
			"0": 2.6486
		},
		"and_uc": {
			"0": 9.42514
		},
		"op_mini": {
			"0": 22.8320886287
		},
		"and_chr": {
			"0": 12.75514
		},
		"and_ff": {
			"0": 0.01938
		}
	},
	"total": 98.04018
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GM.json
 ** module id = 533
 ** module chunks = 0
 **/